export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
  i18nCountries: any
  id: string
}

export type HookProps = Omit<Props, "i18nCountries">

export interface Article {
  articleId: string,
  authors: string[],
  description?: string,
  link?: string,
  publishedIn: string,
  publishingLocation: string,
  publishingYear: string,
  title: string,
  tags: string[],
}
